(ns common.specs.questionnaire
  (:require [clojure.spec.alpha :as s]

            [common.specs.universal]))

(s/def :questionnaire/uuid :common/uuid)
(s/def :questionnaire/partition-key :common/uuid)

(s/def :questionnaire-response/uuid :common/uuid)
(s/def :questionnaire-response/partition-key :common/uuid)

(s/def ::questionnaire
  (s/keys :opt-un [:questionnaire/uuid]))
